addEventListener('turbo:frame-missing', () => {

	const toastDiv = document.createElement("div")
	toastDiv.className = "toast show animated fadeInDown border-danger"
	toastDiv.dataset.controller = "toast"

	toastDiv.innerHTML = `
<div class="toast-header text-danger">
	<div class="fa fal me-3 fa-exclamation-triangle text-danger"></div>
	<div class="me-auto text-danger">Error</div>
	<button aria-label="close" class="btn-close" data-action="click->toast#closeToast" type="button"></button>
</div>
<div class="toast-body">The server failed to give a proper response, please contact an adminstrator.</div>
	`
	
	document.getElementById('toast-container').append(toastDiv)
})

addEventListener('turbo:fetch-request-error', () => {

	const toastDiv = document.createElement("div")
	toastDiv.className = "toast show animated fadeInDown border-danger"
	toastDiv.dataset.controller = "toast"

	toastDiv.innerHTML = `
<div class="toast-header text-danger">
	<div class="fa fal me-3 fa-exclamation-triangle text-danger"></div>
	<div class="me-auto text-danger">Error</div>
	<button aria-label="close" class="btn-close" data-action="click->toast#closeToast" type="button"></button>
</div>
<div class="toast-body">There is a problem with your network connection, the request has failed.</div>
	`
	
	document.getElementById('toast-container').append(toastDiv)
})
